module.exports = __webpack_public_path__ + "static/media/9-item-d.c823c471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/9-item-d.jpg
// module id = 1218
// module chunks = 33